import React, { useState, useEffect, useContext } from "react";
import UserAnalyticsReadOnlyRow from "./UserAnalyticsReadOnlyRow";
import UserAnalyticsTableRow from "./UserAnalyticsTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";


function UserAnalyticsTable({ key, setAnalytics, loginId, companyId }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);
    const [error, setError] = useState("");
    const [isUserAnalyticsLoading, setIsUserAnalyticsLoading] = useState(false);
    const [isAnalyticsNameLoading, setIsAnalyticsNameLoading] = useState(false);
    const [analyticsNames, setAnalyticsNames] = useState([]);
    const [userAnalytics, setUserAnalytics] = useState([]);
    const [count, setCount] = useState(0);
    const closeText = t("page.close");
    const userCtx = useContext(UserContext);

    const initialValues = {
        loginId: loginId,
        companyId: companyId,
        analyticsKey: 0,
    };
    const [formValues, setFormValues] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };

    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
    useEffect(() => {
        fetchAnalyticsNames();
        fetchUserAnalytics();
    }, []);

    const handleClose = (event) => {
        setAnalytics(false);
    };
    function fetchAnalyticsNames() {
        setError("");
        setIsAnalyticsNameLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false
            }),
        };
        try {
            FetchUtil.fetchAPI("GetAnalyticsNames", "/Service/StaticHelper/GetAnalyticsNames", requestOptions, retrieveAnalyticsNameSuccess, retrieveAnalyticsNameFail);
        } catch (error) {
            setIsAnalyticsNameLoading(false);
            throw new Error(error.message);
        }
    }

    function retrieveAnalyticsNameFail(redirect) {
        setIsAnalyticsNameLoading(false);
        if (redirect) {
            navigate("/");
        }
        //setError(t("error.getAnalyticsFailed"));
    }

    function retrieveAnalyticsNameSuccess(responseData) {
        let getAnalyticsNameResponse;
        if (responseData) {
            getAnalyticsNameResponse = responseData.getAnalyticsNameResponse;
            if (getAnalyticsNameResponse && getAnalyticsNameResponse.errorCode === "0") {
                setAnalyticsNames(getAnalyticsNameResponse.analyticsList.slice())
            } else if (getAnalyticsNameResponse && getAnalyticsNameResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getAnalyticsNameResponse) {
                setError(t("error.error") + " " + getAnalyticsNameResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsAnalyticsNameLoading(false);
    }

    function fetchUserAnalytics() {
        setError("");
        if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
            return;
        }
        resetCounter();
        setIsUserAnalyticsLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true, companyId: initialValues.companyId,
                loginId: initialValues.loginId, userCompanyId: userCompanyId
            }),
        };
        try {
            FetchUtil.fetchAPI("GetUserAnalytics", "/Service/UserService/GetUserAnalytics", requestOptions, retrieveUserAnalyticsSuccess, retrieveUserAnalyticsFail);
        } catch (error) {
            setIsUserAnalyticsLoading(false);
            throw new Error(error.message);
        }
    }

    function retrieveUserAnalyticsFail(redirect) {
        setIsUserAnalyticsLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.userGetAnalyticsFailed"));
    }

    function retrieveUserAnalyticsSuccess(responseData) {
        let fetchUserAnalyticsResponse;
        if (responseData) {
            fetchUserAnalyticsResponse = responseData.fetchUserAnalyticsResponse;
            if (fetchUserAnalyticsResponse && fetchUserAnalyticsResponse.errorCode === "0") {
                setUserAnalytics(fetchUserAnalyticsResponse.analyticsList.slice())
            } else if (fetchUserAnalyticsResponse && fetchUserAnalyticsResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchUserAnalyticsResponse) {
                setError(t("error.error") + " " + fetchUserAnalyticsResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsUserAnalyticsLoading(false);
    }

    const handleDeleteClick = (event, userAnalytics, completeCallback) => {
        event.preventDefault();
        deleteUserAnalytics(userAnalytics, completeCallback);
    };
    const deleteUserAnalytics = (userAnalytics, completeCallback) => {
        let action = 3;
        if (userAnalytics.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            loginId: formValues.loginId,
            analyticsKey: userAnalytics.analyticsKey,
            userCompanyId: userCompanyId,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("DeleteUserAnalytics", "/Service/UserService/DeleteUserAnalytics", requestOptions, deleteUserAnalyticsSuccess, deleteUserAnalyticsFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function deleteUserAnalyticsFail(redirect, completeCallback) {
        setError(t("error.userAnalyticsEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deleteUserAnalyticsSuccess(responseData, completeCallback) {
        let deleteUserAnalyticsResponse;
        if (responseData) {
            deleteUserAnalyticsResponse = responseData.deleteUserAnalyticsResponse;
            if (deleteUserAnalyticsResponse) {
                if (deleteUserAnalyticsResponse.errorCode === "0") {
                    resetRowTable();
                    refreshUserAnalytics();
                } else {
                    setError(t("error.error") + " " +
                        deleteUserAnalyticsResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };
    const addRowTable = () => {
        setError("");
        if (!add) {
            setAdd(true);
        } else {
            setError(t("error.only1RowAllowed"));
        }

    };
    const removeRowTable = () => {
        setError("");
        resetRowTable();
    };
    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
    };
    const handleSubmit = (action, setValues, completeCallback) => {
        setError("");
        let found = false;
        if (!formValues.loginId) {
            setError(t("error.userReqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (userAnalytics.length > 0) {
                userAnalytics.map((userAnalyticsItem, index) => {
                    if (userAnalyticsItem.analyticsKey === setValues.analyticsKey) {
                        setError(t("error.userAnalyticsDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                saveUserAnalytics(action, setValues, completeCallback);
            } else {
                if (completeCallback) {
                    completeCallback();
                }
            }
        } else if (action === 2) {
            if (userAnalytics.length > 0) {
                userAnalytics.map((userAnalyticsItem, index) => {
                    if (userAnalyticsItem.analyticsKey === setValues.analyticsKey) {
                        found = true;
                    }
                })
            }
            if (found) {
                saveUserAnalytics(action, setValues, completeCallback);
            } else {
                if (completeCallback) {
                    completeCallback();
                }
            }
        } else if (completeCallback) {
            completeCallback();
        }
    };
    const saveUserAnalytics = (action, setValues, completeCallback) => {
        let serverParams = {
            loginId: formValues.loginId,
            companyId: formValues.companyId,
            analyticsKey: setValues.analyticsKey,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdateUserAnalytics", "/Service/UserService/AddUpdateUserAnalytics", requestOptions, saveUserAnalyticsSuccess, saveUserAnalyticsFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function saveUserAnalyticsFail(redirect, completeCallback) {
        setError(t("error.userAnalyticsEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function saveUserAnalyticsSuccess(responseData, completeCallback) {
        let addUpdateUserAnalyticsResponse;
        if (responseData) {
            addUpdateUserAnalyticsResponse = responseData.addUpdateUserAnalyticsResponse;
            if (addUpdateUserAnalyticsResponse) {
                if (addUpdateUserAnalyticsResponse.errorCode === "0") {
                    resetRowTable();
                    refreshUserAnalytics();
                } else {
                    setError(t("error.error") + " " +
                        addUpdateUserAnalyticsResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
    function refreshUserAnalytics() {
        fetchUserAnalytics();
    }
    return (
        <>
            {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                <div className="container-fluid container_list_sm viewh-85">
                    <div className="row">
                        <div className="col mt-3">
                            {(error) ? (
                                <div id="inerrorMessage" className="errorblock">
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                        {(isUserAnalyticsLoading || isAnalyticsNameLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <table className="list-table" role="table">
                                <thead>
                                    <tr role="row">
                                        <th className="list-th">{t("page.analytics.name")}</th>
                                        <th className="list-th">{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody role="rowgroup">
                                    {add && addRowTop &&
                                        <UserAnalyticsTableRow
                                            index={count}
                                            analyticsNames={analyticsNames}
                                            handleSubmit={handleSubmit}
                                            setError={setError}
                                            t={t}
                                            setAdd={setAdd}
                                            oddIdx={((userAnalytics.length % 2) > 0) ? true : false} />
                                    }
                                    {(userAnalytics.length > 0) ? (
                                        userAnalytics.map((userAnalyticsItem, index) => (
                                            <UserAnalyticsReadOnlyRow
                                                index={count}
                                                t={t}
                                                userAnalyticsItem={userAnalyticsItem}
                                                handleDeleteClick={handleDeleteClick}
                                                oddIdx={((index % 2) > 0) ? true : false}
                                                setError={setError}
                                            />
                                        ))
                                    ) : (<></>)}
                                    {add && addRowBottom &&
                                        <UserAnalyticsTableRow
                                            index={count}
                                            analyticsNames={analyticsNames}
                                            handleSubmit={handleSubmit}
                                            setError={setError}
                                            t={t}
                                            setAdd={setAdd}
                                            oddIdx={((userAnalytics.length % 2) > 0) ? true : false} />
                                    }
                                </tbody>
                                {(userAnalytics.length > 10) ? (<tfoot>
                                    <tr role="row">
                                        <th className="list-th">{t("page.analytics.name")}</th>
                                        <th className="list-th">{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </tfoot>
                                ) : (<></>)}
                            </table>
                            <div className="row">
                                <div className="col mt-3">
                                    {(error) ? (
                                        <div id="inerrorMessage1" className="errorblock">
                                            {error}
                                        </div>
                                    ) : (<></>)}
                                </div>
                            </div>
                            <div className="footer">
                                <input
                                    type="button"
                                    name="edit-user-analytics-close"
                                    id="edit-user-analytics-close"
                                    className="btn btn-secondary btn-block" data-dismiss="modal"
                                    onClick={(e) => handleClose(e)}
                                     style={{ marginTop: "10px", marginBottom: "10px" }}
                                    value={closeText}
                                ></input>
                            </div>
                        </div>
                    </div>
                </div>
                : null}
        </>
    );
}
export default UserAnalyticsTable;